import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainResume from './pages/MainPage/MainResume';
import ScrollToTop from './scrollToTop';
import { useRecoilState } from 'recoil';
import { getAuth } from './recoil';
import { useEffect, useState } from 'react';
import ChannelTalkContext from './context/ChannelTalkContext';
import ResponsiveMobileMainResume from './pages/MainPage/ResponsiveMobileMainResume';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import PrivacyPolicyRevisionPage from './pages/PrivacyPolicyPage/PrivacyPolicyRevisionPage';
import TransferRedirect from './components/Public/TransferRedirect';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [auth, setAuth] = useRecoilState(getAuth);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  if (!auth) {
    return (
      <Router>
        <ScrollToTop />
        <Routes>
          {windowWidth > 1200 ? (
            <>
              <Route
                path="/resume"
                element={<MainResume />}
              />
              <Route
                path="/resume/write"
                element={<TransferRedirect from="resume-write" />}
              />
              <Route
                path="/resume/read"
                element={<TransferRedirect from="resume-read" />}
              />
              {/* <Route
                path="/resume/inquiry"
                element={<TransferRedirect from="resume-inquiry" />}
              /> */}
              <Route
                path="/resume/privacy-policy"
                element={<PrivacyPolicyPage />}
              />
              <Route
                path="/resume/privacy-policy/revision"
                element={<PrivacyPolicyRevisionPage />}
              />
              <Route
                path="/resume/notice"
                element={<TransferRedirect from="resume-notice" />}
              />
              <Route
                path="/resume/recruitlist"
                element={<TransferRedirect from="resume-recruitlist" />}
              />
              <Route
                path="resume/recruitapply"
                element={<TransferRedirect from="resume-recruitapply" />}
              />
              <Route
                path="*"
                element={<Navigate to="/resume" />}
              />
            </>
          ) : (
            <>
              <Route
                path="/resume"
                element={<ResponsiveMobileMainResume />}
              />
              <Route
                path="/resume/write"
                element={<TransferRedirect from="resume-write" />}
              />
              {/* <Route
                path="/resume/inquiry"
                element={<TransferRedirect from="resume-inquiry" />}
              /> */}
              <Route
                path="/resume/privacy-policy"
                element={<PrivacyPolicyPage />}
              />
              <Route
                path="/resume/privacy-policy/revision"
                element={<PrivacyPolicyRevisionPage />}
              />
              <Route
                path="/resume/notice"
                element={<TransferRedirect from="resume-notice" />}
              />
              <Route
                path="*"
                element={<Navigate to="/resume" />}
              />
            </>
          )}
        </Routes>
      </Router>
    );
  }
  return (
    <Router>
      <ScrollToTop>
        <Routes>
          {windowWidth > 1200 ? (
            <>
              <Route
                path="/resume"
                element={<MainResume />}
              />
              <Route
                path="/resume/write"
                element={<TransferRedirect from="resume-write" />}
              />
              <Route
                path="/resume/read"
                element={<TransferRedirect from="resume-read" />}
              />
              <Route
                path="/resume/list"
                element={<TransferRedirect from="resume-read" />}
              />
              <Route
                path="/resume/detail"
                element={<TransferRedirect from="resume-read" />}
              />
              {/* <Route
                path="/resume/inquiry"
                element={<TransferRedirect from="resume-inquiry" />}
              /> */}
              <Route
                path="/resume/privacy-policy"
                element={<PrivacyPolicyPage />}
              />
              <Route
                path="/resume/privacy-policy/revision"
                element={<PrivacyPolicyRevisionPage />}
              />
              <Route
                path="/resume/notice"
                element={<TransferRedirect from="resume-notice" />}
              />
              <Route
                path="/resume/recruitlist"
                element={<TransferRedirect from="resume-recruitlist" />}
              />
              <Route
                path="resume/recruitapply"
                element={<TransferRedirect from="resume-recruitapply" />}
              />
              <Route
                path="*"
                element={<Navigate to="/resume" />}
              />
            </>
          ) : (
            <>
              <Route
                path="/resume"
                element={<ResponsiveMobileMainResume />}
              />
              <Route
                path="/resume/write"
                element={<TransferRedirect from="resume-write" />}
              />
              {/* <Route
                path="/resume/inquiry"
                element={<TransferRedirect from="resume-inquiry" />}
              /> */}
              <Route
                path="/resume/privacy-policy"
                element={<PrivacyPolicyPage />}
              />
              <Route
                path="/resume/privacy-policy/revision"
                element={<PrivacyPolicyRevisionPage />}
              />
              <Route
                path="/resume/notice"
                element={<TransferRedirect from="resume-notice" />}
              />

              <Route
                path="*"
                element={<Navigate to="/resume" />}
              />
            </>
          )}
        </Routes>
      </ScrollToTop>
    </Router>
  );
}

export default App;
